import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import store from "../../../store";
import { setETLProcessListData } from "../../../features/etlProcessListSlice";
import { etlProcessListService } from "../../../services/api/etl-process-list.endpoints";

async function getETLProcessList(
  oauthTokenHeader: string,
  setETLProcessContent: any,
  trackPromise: any
) {
  try {
    const response = await etlProcessListService.getETLProcessList(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Something went wrong while Getting ETL Process List",
            type: "error",
          })
        )
      );
    } else {
      setETLProcessContent(response?.data?.data);
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getProcessList(oauthTokenHeader: string, setETLProcessContent: any,trackPromise: any) {
  try {
    const response = await etlProcessListService.getProcessList(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      trackPromise(store.dispatch(setDisplayErrorSnackBar({message: "Something went wrong while Getting ETL Process List",type: "error",})));
    } else {
      setETLProcessContent(response?.data?.data);
    }
  } catch (e:any) {
    trackPromise(store.dispatch(setDisplayErrorSnackBar({message: e.parsedText || "Unknown error occurred", type: "error",})));
  }
}

//Duplicate ETLProcessList get API with implemented redux functionality, because it is manupulating other module (ETL Process logs) (might be deleted in future)
async function getETLProcessListDuplicate(
  oauthTokenHeader: string,
  dispatch: any
) {
  try {
    const response = await etlProcessListService.getETLProcessList(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Getting ETL Process List",
          type: "error",
        })
      );
    } else {
      dispatch(setETLProcessListData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function createETLProcess(
  oauthTokenHeader: string,
  setETLProcess: any,
  trackPromise: any,
  data: any,
  setLoad: any
) {
  try {
    setLoad(true);
    const response = await etlProcessListService.createETLProcess(
      data,
      oauthTokenHeader
    );
    if (!response?.status || response?.status !== 201) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Something went wrong while Creating ETL Process List",
            type: "error",
          })
        )
      );
    } else {
      setETLProcess("success");
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Process Created Successfully",
          type: "success",
        })
      );
      setLoad(false);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    setETLProcess(e);
    setLoad(false);
  }
}

async function editETLProcess(
  oauthTokenHeader: string,
  setEditETLProcess: any,
  trackPromise: any,
  data: any
) {
  try {
    const response = await etlProcessListService.editETLProcess(
      data,
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Something went wrong while Edit ETL Process List",
            type: "error",
          })
        )
      );
    } else {
      setEditETLProcess(response?.data);
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function toggleETLProcess(
  oauthTokenHeader: string,
  setEditETLProcess: any,
  trackPromise: any,
  data: any,
  processId: number
) {
  try {
    const response = await etlProcessListService.toggleETLProcess(
      processId,
      data,
      oauthTokenHeader
    );
    if (!response?.status || response?.status !== 204) {
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Something went wrong while toggle ETL Process List",
            type: "error",
          })
        )
      );
    } else {
      setEditETLProcess(response);
    }
  } catch (e: any) {
    if (e?.status !== undefined) {
      setEditETLProcess(e?.parsedText?.reason);
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: e?.parsedText || "Unknown error occurred",
            type: "error",
          })
        )
      );
    } else
      trackPromise(
        store.dispatch(
          setDisplayErrorSnackBar({
            message: "Toggle Successfull",
            type: "success",
          })
        )
      );
  }
}

async function getUsers(oauthTokenHeader: string, setUsers: any) {
  try {
    const response = await etlProcessListService.getAllUsers(oauthTokenHeader);
    if (!response?.data?.data) {
      throw new Error("Failed to fetch user data");
    }
    setUsers(response.data.data ?? []);
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

export const ETLProcessListEndPointLogic = {
  getETLProcessList,
  getProcessList,
  getETLProcessListDuplicate,
  createETLProcess,
  editETLProcess,
  toggleETLProcess,
  getUsers,
};
